import { panelType } from '@bimser/common';
import { BCCard, BCScrollbars, BCSkeleton, ContentType } from '@bimser/components';
import React from 'react';
import Style from '../../assets/style.scss';
import ICountTileProps from '../../entities/widgets/ICountTileProps';
import { tiles, tileTypeAndKeys } from '../../utils';
import { TileTypes } from '../../entities/widgets/TileTypes';
import classNames from 'classnames/bind';
const cx = classNames.bind(Style);

export default (props: ICountTileProps) => {
	const setSelectedTile = (tile: TileTypes) => {
		props.onChangeSelected({
			panelId: props.panelId,
			panelType: panelType.startupLayout,
			data: tile
		});
	};

	return (
		<div className={Style.tileCardListContainer}>
			<BCScrollbars mountScrollPosition="bottom">
				<BCSkeleton
					loadingStatus={props.loading}
					contentType={ContentType.DashboardTilesList}
					height={130}
				>
					<div className={Style.tileCardList}>
						{Object.values(tiles[props.dashboardType]()).map(tileObject => {
							const id = Object.keys(tileTypeAndKeys).find(
								key => tileTypeAndKeys[key] == tileObject.key
							);
							const tileBadgeStyle: React.CSSProperties = {
								backgroundColor: tileObject?.badgeColor
							};

							return tileObject ? (
								<span
									onClick={() => setSelectedTile(tileObject.key)}
									key={id}
								>
									<BCCard
										key={id}
										className={cx({
											tileCard: true,
											[id]: true,
											selected: props.selectedTile == tileObject.key
										})}
										bordered={false}
										style={tileBadgeStyle}
										seleniumId={`dashboardCountTiles${
											id.charAt(0).toUpperCase() + id.slice(1)
										}`}
									>
										<span className={Style.tileHeader}>
											{tileObject.caption}
										</span>
										<span className={Style.tileCount}>{props.counts[id]}</span>
									</BCCard>
								</span>
							) : (
								''
							);
						})}
					</div>
				</BCSkeleton>
			</BCScrollbars>
		</div>
	);
};
